import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import { withFormGroup } from '../../common/FormGroup/FormGroup';
import { TEXTAREA_DEFAULT_DISABLED, TEXTAREA_DEFAULT_MODE, TEXTAREA_DEFAULT_ROWS, TEXT_AREA_DEFAULT_ROLE, TEXT_AREA_DEFAULT_SIZE } from './TextArea.constants';
import { TextAreaRoot, TextAreaWrapper } from './TextArea.styled';
// Component.
// -----------------------------------------------------------------------------
const TextArea = withFormGroup(({ disabled = TEXTAREA_DEFAULT_DISABLED, mode = TEXTAREA_DEFAULT_MODE, name, role = TEXT_AREA_DEFAULT_ROLE, rows = TEXTAREA_DEFAULT_ROWS, size = TEXT_AREA_DEFAULT_SIZE, autoGrow = false, inputRef, ...rest }) => {
    const wrapperRef = useRef(null);
    // Render.
    // -------------------------------------------------------------------------
    return (_jsx(TextAreaWrapper, { autoGrow: autoGrow, ref: wrapperRef, children: _jsx(TextAreaRoot, { "aria-label": name, ...(role && { className: role }), disabled: disabled, mode: mode, name: name, ref: inputRef, rows: rows, scale: size, onInput: autoGrow
                ? (e) => {
                    if (wrapperRef.current) {
                        wrapperRef.current.dataset.replicatedValue =
                            e.currentTarget.value;
                    }
                }
                : undefined, ...rest }) }));
});
// Component configuration.
// -----------------------------------------------------------------------------
TextArea.displayName = 'TextArea';
const TextareaWithFormGroup = React.forwardRef((props, ref) => {
    return _jsx(TextArea, { ...props, inputRef: ref });
});
TextareaWithFormGroup.displayName = 'TextareaWithFormGroup';
export default TextareaWithFormGroup;
//# sourceMappingURL=TextArea.js.map